/**
 * @file m站 个人中心
 */

import React, {Component} from 'react';
import storage from 'store'
import {NavBar, List, Toast, Modal, Icon} from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent'
import {Http, urls} from '../../api/index';
import {phoneType} from '../../util/base';
import './my.scss';

const Item = List.Item;

class My extends Component {
    constructor(props) {
        super(props);
        props.cacheLifecycles.didCache(this.componentDidCache);
        props.cacheLifecycles.didRecover(this.componentDidRecover);
        this.state = {
            footer: `开发票、查违章、实名&驾照认证等事项，请咨询取车门店或拨打24H客服热线${window.LXOptions.qaMobile}`,
            user: {
                name: '',
                phone: '',
                avatar: ''
            },
            userInfo: {
                balance: '-',
                couponNum: '-',
                bankcardNum: '-'
            },
            tagData: [
                { date: '2019-07-14', disable: true },
                { date: '2019-07-28', disable: true },
            ],
            info: {},
            isqueryNotCompletedNum: {}
        };
    }

    componentDidMount() {
        this.init();
    }
    componentWillReceiveProps(props){
    }
    componentDidCache = () => {}
    componentDidRecover = () => {
        this.init()
    }
    init() {
        this.setState(() => {
            return {loading: true};
        });
        this.queryNotCompletedNum();
        this.getMoney();
    }

    async queryNotCompletedNum() {
        const url = urls.queryNotCompletedNumJson;
        await Http.post({ url }).then(res => {
            if (res.code == 0) {
                this.setState({
                    isqueryNotCompletedNum: res.data
                })
            } else {
                Toast.info(res.msg);
            }
        })
    }

    async getMoney() {
        const user = storage.get('user') || {}
        const isuser = (JSON.stringify(user) == "{}")
        if (isuser) {
            this.setState({
                info: {}
            })
        } else {
          let info = await Http.post({ url: urls.mywallet })
            this.setState({
                info,
                userInfo: info.data
            })
        }

        this.setState({
            user: {
                name: user.name,
                phone: user.phone,
                avatar: user.userIcon
            }
        })
        // if (!isuser) {
        //   alert('userInfo')
        //     this.setState({
        //         userInfo: this.state.info.data
        //     })
        // }
    }

    goLogin() {
        const {history} = this.props
        history.push({
            pathname: '/login'
        })
    }

    goCoupon() {
        const {history} = this.props
        history.push({
            pathname: '/couponList'
        })
    }

    goRouteOrderList() {
        Http.post({ url: urls.mywallet }).then((res)=>{
            const {history} = this.props
            history.push({
                pathname: '/routeOrderList'
            })
        })
       
    }

    goHelp() {
        const {history} = this.props
        history.push({
            pathname: '/helpCenter'
        })
    }

    bindCard() {
        const {history} = this.props
        history.push({
            pathname: '/cardList'
        });
    }

    balance() {
        Toast.info('暂不支持余额操作，请移步APP哦~');
    }

    loginout() {
        Modal.alert('退出', '您确认么？', [
            { text: '取消', onPress: () => {} },
            { text: '确定', onPress: () => {
                // setTimeout(() => {
                    // const {history} = this.props
                    // history.go(0)
                    this.setState({
                        userInfo: {
                            balance: '-',
                            couponNum: '-',
                            bankcardNum: '-'
                        }
                    }, () => {
                      storage.remove('user');
                      storage.remove('serialNo');
                      setTimeout(() => {
                        window.location.replace('/')
                      }, 500)
                    });
                  
                // }, 0);
            } }
        ])
    }

    // 返回app
    goBackApp() {
        const u = navigator.userAgent;
        // 1 Android  2 ios
        if (phoneType(u) === 1) {
            window.izuche.close();
        } else {
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                action: 'back'
            });
        }
        storage.set('source', '');
    }

    render() {
        let isShowLogOut = storage.get('source');
        return (
            <div id="my" className="page">
                <NavBarComponent>
                    {
                        isShowLogOut === 'app'
                        ? <NavBar
                            icon={<Icon type="cross" color='#333' />}
                            onLeftClick={() => {this.goBackApp();}}
                            mode='light'>
                                个人中心
                            </NavBar>
                        : <NavBar mode='light'>个人中心</NavBar>
                    }
                </NavBarComponent>
                <div className="header">
                    <div className="main">
                        <div className="left">
                            {this.state.user.avatar ? 
                            <span className="img" style={{backgroundImage: "url("+ this.state.user.avatar + ")"}}></span> :
                            <span className="img" style={{backgroundImage: "url(/assets/perheader.png)"}}></span>
                            }
                        </div>
                        <div className="right mt10">
                            {this.state.user.phone ? <span><span>{this.state.user.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}</span></span> : <span className="login" onClick={() => {this.goLogin()}}>登录/注册</span>}
                        </div>
                    </div>
                    {
                        isShowLogOut === 'app' ? ''
                        : <div className="ic" onClick={() => {this.loginout()}}>
                            {this.state.user.phone ? 
                                <span className="img" style={{backgroundImage: "url(/assets/exit.png)"}}></span> : 
                                <span></span>
                            }
                        </div>
                    }
                </div>
                <div className="money">
                    <div className="money-info">
                    <div onClick={() => {this.balance()}}>
                        <span>账户余额</span>
                        <span>￥{this.state.userInfo.balance}</span>
                    </div>
                    <div onClick={() => {this.goCoupon()}}>
                        <span>优惠券</span>
                        <span>{this.state.userInfo.couponNum}张</span>
                    </div>
                    </div>
                </div>
                <List>
                    <Item arrow="horizontal" onClick={() => {this.goRouteOrderList()}}>
                        <div className="list-item dpf">
                            <span className="carTrip">
                                <span className="img" style={{backgroundImage: "url(/assets/trip.png)"}}></span>
                                <span className="font13 pl5">行程订单</span>
                            </span>
                            <span>
                                {this.state.isqueryNotCompletedNum.notCompletedOrderNum > 0 ? <span className="iconfont icon-redcircle red fs48"></span> : <span></span>}
                                {this.state.isqueryNotCompletedNum.notCompletedBillNum > 0 ? <span className="iconfont icon-redcircle red fs48"></span> : <span></span>}
                            </span>
                        </div>
                    </Item>
                    <Item arrow="horizontal" onClick={() => {this.goHelp()}}>
                        <div className="list-item">
                            <span className="img" style={{backgroundImage: "url(/assets/suggest.png)"}}></span>
                            <span className="font13 pl5">帮助中心</span>
                        </div>
                    </Item>
                    <Item arrow="horizontal" onClick={() => {this.bindCard()}}>
                        <div className="list-item">
                            <span className="img" style={{backgroundImage: "url(/assets/xinyongka.png)"}}></span>
                            <span className="font13 pl5">信用卡</span>
                        </div>
                    </Item>
                </List>
                <div className="footer">
                    <span className="c9">{this.state.footer}</span>
                </div>
            </div>
        );
    }
}

export default My;
